<template>
  <v-card class="ma-3 pa-3">
    <v-card-title>
      <h2>
        {{ $t('CONTROL CONTABLE') }} - {{ year }} - {{ $t('TRIMESTRE') }}
        {{ selectedQuarter }}
      </h2>
    </v-card-title>

    <!-- Top buttons -->
    <v-layout align-center justify-start row fill-height>
      <div class="ml-1">
        <v-btn color="primary" @click="openCreateAccountingControlDialog()">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('Añadir') }}
        </v-btn>
      </div>
      <div class="ml-3">
        <v-btn color="light" @click="openCloneQuarterDialog()">
          <v-icon left>mdi-content-copy</v-icon>
          {{ $t('Clonar Trimestre') }}
        </v-btn>
      </div>
      <div class="ml-3">
        <v-btn color="light" @click="exportToExcel()" :disabled="exportingExcel">
          <v-icon left>mdi-file-excel-outline</v-icon>
          {{ $t('Exportar a excel') }}
          <v-progress-circular
            v-if="exportingExcel"
            class="ml-2"
            :size="20"
            indeterminate
            color="black"
          ></v-progress-circular>
        </v-btn>
      </div>
      <!--      <div class="ml-3">-->
      <!--        <v-btn color="light" @click="syncDocumentStatus()" :disabled="updatingDocumentStatus">-->
      <!--          <v-icon left>mdi-folder-sync</v-icon>-->
      <!--          {{ $t('Actualizar estados') }}-->
      <!--          <v-progress-circular-->
      <!--            v-if="updatingDocumentStatus"-->
      <!--            class="ml-2"-->
      <!--            :size="20"-->
      <!--            indeterminate-->
      <!--            color="black"-->
      <!--          ></v-progress-circular>-->
      <!--        </v-btn>-->
      <!--      </div>-->
      <div class="ml-3" v-if="this.selectedItems.length >= 1">
        <v-btn color="error" @click="showDeleteAccountingControlForm = true">
          <v-icon left>mdi-delete</v-icon>
          {{ $t('Eliminar') }}
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div class="ml-3">
        <og-saved-filters
          scope="accounting_control"
          :current="savedFiltersState"
          @apply="applySavedFilters"
          @saved="showSnackMessage('success', $event)"
          @error="showSnackMessage('error', $event)"
        />
      </div>
      <div class="ml-3">
        <og-table-view-toggle v-model="compactView" />
      </div>
    </v-layout>
    <!-- End add customers -->

    <!-- Filters -->
    <v-layout align-center justify-end row fill-height>
      <div class="ml-3">
        <v-autocomplete
          color="primary"
          v-model="filters.consultant_ids"
          multiple
          chips
          deletable-chips
          :items="consultantsFilterList"
          :label="$t('Asesor/a *')"
          row
        ></v-autocomplete>
      </div>
      <div class="ml-3">
        <v-select
          color="primary"
          v-model="year"
          item-text="text"
          item-value="value"
          :items="years"
          row
          :label="$t('Año')"
        ></v-select>
      </div>
      <div class="ml-3">
        <v-btn-toggle v-model="quarter">
          <v-btn color="primary" value="1">
            {{ $t('T1') }}
          </v-btn>
          <v-btn color="primary" value="2">
            {{ $t('T2') }}
          </v-btn>
          <v-btn color="primary" value="3">
            {{ $t('T3') }}
          </v-btn>
          <v-btn color="primary" value="4">
            {{ $t('T4') }}
          </v-btn>
        </v-btn-toggle>
      </div>
    </v-layout>
    <v-layout row justify-end wrap class="mb-3">
      <v-flex xs12 md3>
        <v-layout row justify-end wrap style="border: dashed darkgrey 1px">
          <v-flex xs12 md6>
            <div class="ml-3">
              <v-select
                color="primary"
                v-model="filters.selectedDocumentType"
                item-text="text"
                item-value="value"
                :items="documentTypes"
                :clearable="true"
                row
                :label="$t('Tipo de documento')"
              ></v-select>
            </div>
          </v-flex>
          <v-flex xs12 md6>
            <div class="ml-3 mr-3">
              <v-select
                color="primary"
                v-model="filters.selectedDocumentStatus"
                item-text="text"
                item-value="value"
                :items="monthlyStatusOptions"
                :clearable="true"
                row
                :label="$t('Estado del documento')"
              ></v-select>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md3>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.columns"
            item-text="text"
            item-value="value"
            :items="filterColumnsList"
            :clearable="true"
            row
            :multiple="true"
            :label="$t('Mostrar columnas')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.controlStatus"
            item-text="text"
            item-value="value"
            :items="controlStatusOptions"
            :clearable="true"
            row
            :label="$t('Estado contable')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.defaulterControl"
            item-text="text"
            item-value="value"
            :items="defaulterControlOptions"
            :clearable="true"
            row
            :label="$t('Ctrl. incumplidores')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md1>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.has_billing_module"
            item-text="text"
            item-value="value"
            :items="[
              { text: 'TODOS', value: null },
              { text: 'SÍ', value: true },
              { text: 'NO', value: false },
            ]"
            :clearable="true"
            row
            :label="$t('Mod. Fact.')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md1>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.inmatic"
            item-text="text"
            item-value="value"
            :items="[
              { text: 'TODOS', value: null },
              { text: 'SÍ', value: true },
              { text: 'NO', value: false },
            ]"
            :clearable="true"
            row
            :label="$t('Inmatic')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-text-field
            v-model="filters.search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <!-- End filters -->

    <!-- Modal to add new customers -->
    <v-layout row justify-center>
      <v-dialog v-model="showCreateAccountingControlForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Añadir Empresas') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="form.year"
                    :items="years"
                    :label="$t('Año *')"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="form.quarter"
                    :items="[
                      { text: 'Trimestre 1', value: 1 },
                      { text: 'Trimestre 2', value: 2 },
                      { text: 'Trimestre 3', value: 3 },
                      { text: 'Trimestre 4', value: 4 },
                    ]"
                    :label="$t('Trimestre *')"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    v-model="form.consultant_id"
                    :items="consultantsList"
                    :label="$t('Asesor/a *')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="form.tax_regime"
                    :items="taxRegimeOptions"
                    :label="$t('Reg. Fiscal *')"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="form.allCompanies"
                    :label="$t('Añadir todas las empresas activas en este momento')"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :disabled="form.allCompanies"
                    v-model="form.companies"
                    :items="companiesList"
                    :label="$t('Empresas *')"
                    multiple
                    chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    :label="$t('Observaciones')"
                    auto-grow
                    :value="form.observations"
                    rows="1"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <small>{{ $t('* Campos obligatorios') }}</small>
            <v-alert :value="form.showValidationErrors" color="error" icon="warning" outline>
              {{ $t('No has seleccionado todos los campos obligatorios') }}
            </v-alert>
            <v-container v-if="creatingAccountingControl">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="creatingAccountingControl"
              color="blue darken-1"
              flat
              @click="showCreateAccountingControlForm = false"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="creatingAccountingControl"
              @click="createAccountingControl()"
            >
              {{ $t('Añadir') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Modal to delete customers -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteAccountingControlForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar el control contable de las empresas seleccionadas?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showDeleteAccountingControlForm = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="deleteAccountingControl()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Modal to clone quarters -->
    <v-layout row justify-center>
      <v-dialog v-model="showCloneQuarterForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Clonar trimestre') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>Selecciona el año y trimestre que quieres clonar y los datos de destino</h2>
                  <small class="font-weight-bold text-red">
                    Se eliminarán aquellas empresas que ya estén registradas en el trimestre de
                    destino
                  </small>
                </v-flex>
                <v-layout wrap class="mt-4">
                  <v-flex xs12>
                    <h3>ORIGEN</h3>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.originYear"
                        item-text="text"
                        item-value="value"
                        :items="years"
                        row
                        :label="$t('Año')"
                      ></v-select>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.originQuarter"
                        item-text="text"
                        item-value="value"
                        :items="[
                          { text: 'Trimestre 1', value: '1' },
                          { text: 'Trimestre 2', value: '2' },
                          { text: 'Trimestre 3', value: '3' },
                          { text: 'Trimestre 4', value: '4' },
                        ]"
                        :label="$t('Trimestre')"
                        row
                      ></v-select>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
                    <h3>DESTINO</h3>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.destinyYear"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: nextYear, value: nextYear }].concat(years)"
                        row
                        :label="$t('Año')"
                      ></v-select>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.destinyQuarter"
                        item-text="text"
                        item-value="value"
                        :items="[
                          { text: 'Trimestre 1', value: '1' },
                          { text: 'Trimestre 2', value: '2' },
                          { text: 'Trimestre 3', value: '3' },
                          { text: 'Trimestre 4', value: '4' },
                        ]"
                        :label="$t('Trimestre')"
                        row
                      ></v-select>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
            <v-alert :value="clone.showValidationErrors" color="error" icon="warning" outline>
              {{ $t('Todos los campos son obligatorios') }}
            </v-alert>
            <v-container v-if="cloningAccountingControl">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="showCloneQuarterForm = false"
              :disabled="cloningAccountingControl"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="cloneAccountingControl()"
              :disabled="cloningAccountingControl"
            >
              {{ $t('Clonar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Modal to bulk edit -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkEditForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Edición múltiple: ') + bulk.fieldText }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h3>Se aplicará a todos los elementos seleccionados</h3>
                  <h3
                    class="text-red"
                    v-if="
                      bulk.fieldValue
                        ? bulk.fieldValue.includes('openges') ||
                          bulk.fieldValue.includes('payroll') ||
                          bulk.fieldValue.includes('defaulter')
                        : false
                    "
                  >
                    Si no selecciona ninguna opción se eliminará el estado actual
                  </h3>
                  <h3 class="text-red" v-if="bulk.fieldValue === 'active'">
                    Si no selecciona ninguna opción se marcarán por defecto como BAJA
                  </h3>
                  <h3 class="text-red" v-if="bulk.fieldValue === 'inmatic'">
                    Si no selecciona ninguna opción se marcarán por defecto como NO
                  </h3>
                  <h3 class="text-red" v-if="bulk.fieldValue === 'consultant'">
                    Si no selecciona ninguna opción se eliminarán las asignaciones actuales
                  </h3>
                </v-flex>
                <v-layout wrap class="mt-4">
                  <v-flex xs12>
                    <div class="ml-3">
                      <v-autocomplete
                        v-if="bulk.fieldValue && bulk.fieldValue.includes('consultant')"
                        color="primary"
                        v-model="bulk.consultant"
                        item-text="text"
                        item-value="value"
                        :items="consultantsList"
                        row
                        :label="$t('Asesor/a')"
                      ></v-autocomplete>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('active')"
                        color="primary"
                        v-model="bulk.active"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: 'ACTIVO', value: true }, { text: 'BAJA', value: false }]"
                        row
                        :label="$t('Estado')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('inmatic')"
                        color="primary"
                        v-model="bulk.inmatic"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"
                        row
                        :label="$t('INMATIC')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('defaulter_control')"
                        color="primary"
                        v-model="bulk.defaulterControl"
                        item-text="text"
                        item-value="value"
                        :items="defaulterControlOptions"
                        row
                        :label="$t('Control Incumplidores')"
                      ></v-select>
                      <v-select
                        v-else-if="
                          bulk.fieldValue && bulk.fieldValue.includes('defaulter_supplement')
                        "
                        color="primary"
                        v-model="bulk.defaulterSupplement"
                        item-text="text"
                        item-value="value"
                        :items="defaulterSupplementOptions"
                        row
                        :label="$t('Suplemento Incumplidores')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('status')"
                        color="primary"
                        v-model="bulk.status"
                        item-text="text"
                        item-value="value"
                        :items="controlStatusOptions.filter(item => item.value !== 'SIN_DATOS')"
                        row
                        :label="$t('Estado Contable')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('tax_regime')"
                        color="primary"
                        v-model="bulk.taxRegime"
                        item-text="text"
                        item-value="value"
                        :items="taxRegimeOptions"
                        row
                        :label="$t('Régimen fiscal')"
                      ></v-select>
                      <v-select
                        v-else-if="
                          bulk.fieldValue &&
                            (bulk.fieldValue.includes('openges') ||
                              bulk.fieldValue.includes('payroll') ||
                              bulk.fieldValue.includes('issued') ||
                              bulk.fieldValue.includes('received') ||
                              bulk.fieldValue.includes('banking'))
                        "
                        color="primary"
                        v-model="bulk.invoiceStatus"
                        item-text="text"
                        item-value="value"
                        :items="monthlyStatusOptions"
                        row
                        :label="$t('Estado')"
                      ></v-select>
                      <v-text-field
                        v-else
                        v-model="bulk.text"
                        :label="$t(`${this.bulk.fieldText}`)"
                      ></v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
            <v-container v-if="bulkSavingAccountingControl">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="showBulkEditForm = false"
              :disabled="bulkSavingAccountingControl"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="saveBulkEditForm()"
              :disabled="bulkSavingAccountingControl"
            >
              {{ $t('Guardar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Data table with accounting control -->
    <v-data-table
      v-sticky-columns="'accounting-control'"
      :class="{ 'og-compact-table': compactView }"
      ref="accountingControlTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="accountingControlItems"
      :pagination.sync="accountingControlPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="accountingControlPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0" class="og-sticky-col og-sticky-col--no-resize">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <!-- Filter selected columns -->
            <template
              v-if="filters.columns.includes('all') || filters.columns.includes(header.value)"
            >
              <th
                :key="`th_${header.value}`"
                :data-sticky-key="header.value"
                :class="[
                  'text-xs-center',
                  isStickyColumn(header.value) ? 'og-sticky-col' : '',
                  header.sortable ? 'column sortable' : '',
                  accountingControlPagination.descending ? 'desc' : 'asc',
                  header.value === accountingControlPagination.sortBy ? 'active' : '',
                ]"
                @click="
                  header.sortable
                    ? changeSort(header.value)
                    : openBulkEditForm(header.text, header.value)
                "
              >
                <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                <span :class="['og-th-label', { 'og-th-label--short': header.text.length <= 6 }]">
                  {{ header.text }}
                </span>
              </th>
            </template>
            <!-- End filter selected columnas -->
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :style="!props.item.active ? 'background-color: pink' : ''">
          <td class="og-sticky-col">
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <!--          <td class="text-xs-center">{{ props.item.id }}</td>-->
          <td
            class="text-xs-center og-sticky-col"
            v-if="filters.columns.includes('all') || filters.columns.includes('clavedat')"
          >
            {{ props.item.clavedat }}
          </td>
          <td
            class="text-xs-center og-cell-truncate og-sticky-col"
            v-if="filters.columns.includes('all') || filters.columns.includes('name')"
            :title="props.item.name"
          >
            {{ props.item.name }}
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('cif')"
          >
            {{ props.item.cif }}
          </td>
          <td
            class="text-xs-center og-cell-truncate"
            v-if="filters.columns.includes('all') || filters.columns.includes('consultant')"
            :title="props.item.consultant"
          >
            <v-edit-dialog
              :return-value.sync="props.item.consultant_id"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow(props.item)"
            >
              <div>{{ props.item.consultant }}</div>
              <template v-slot:input>
                <div class="mt-3">Asesor/a</div>
                <v-select
                  color="primary"
                  v-model="props.item.consultant_id"
                  item-text="text"
                  item-value="value"
                  :items="consultantsList"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center og-cell-nowrap"
            v-if="filters.columns.includes('all') || filters.columns.includes('tax_regime')"
          >
            <v-edit-dialog
              :return-value.sync="props.item.tax_regime"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.tax_regime }}</div>
              <template v-slot:input>
                <div class="mt-3">Régimen Fiscal</div>
                <v-select
                  color="primary"
                  v-model="props.item.tax_regime"
                  item-text="text"
                  item-value="value"
                  :items="taxRegimeOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('status')"
          >
            <v-edit-dialog
              :return-value.sync="props.item.status"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <og-status-label :value="props.item.status" :compact="compactView" />
              <template v-slot:input>
                <div class="mt-3">Estado Contable</div>
                <v-select
                  color="primary"
                  v-model="props.item.status"
                  item-text="text"
                  item-value="value"
                  :items="editableControlStatusOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('active')"
          >
            <v-edit-dialog
              :return-value.sync="props.item.active"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.active_text }}</div>
              <template v-slot:input>
                <div class="mt-3">Estado Empresa</div>
                <v-select
                  color="primary"
                  v-model="props.item.active"
                  item-text="text"
                  item-value="value"
                  :items="[{ text: 'ACTIVO', value: true }, { text: 'BAJA', value: false }]"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('inmatic')"
          >
            <v-edit-dialog
              :return-value.sync="props.item.inmatic"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.inmatic_text }}</div>
              <template v-slot:input>
                <div class="mt-3">INMATIC</div>
                <v-select
                  color="primary"
                  v-model="props.item.inmatic"
                  BUL
                  item-text="text"
                  item-value="value"
                  :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('billing_module')"
          >
            {{ props.item.billing_module_text }}
          </td>
          <td
            class="text-xs-center og-cell-truncate"
            v-if="filters.columns.includes('all') || filters.columns.includes('observations')"
            :title="props.item.observations"
          >
            <v-edit-dialog
              :return-value.sync="props.item.observations"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.observations }}</div>
              <template v-slot:input>
                <div class="mt-3">Observaciones</div>
                <v-text-field
                  v-model="props.item.observations"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <!-- TRIMESTRE 1 -->
          <template v-if="selectedQuarter === '1'">
            <!-- ENERO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_ene)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_ene')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_ene"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_ene" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Enero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_ene"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_ene)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_ene')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_ene"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_ene" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Enero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_ene"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_ene)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_ene')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_ene"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_ene"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Enero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_ene"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_ene)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_ene')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_ene"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_ene" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Enero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_ene"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_ene)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_ene')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_ene"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_ene" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Enero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_ene"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_ene)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_ene')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_ene"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_ene" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Enero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_ene"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- FEBRERO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_feb)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_feb')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_feb"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_feb" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Febrero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_feb"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_feb)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_feb')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_feb"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_feb" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Febrero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_feb"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_feb)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_feb')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_feb"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_feb"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Febrero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_feb"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_feb)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_feb')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_feb"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_feb" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Febrero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_feb"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_feb)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_feb')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_feb"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_feb" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Febrero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_feb"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_feb)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_feb')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_feb"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_feb" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Febrero</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_feb"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- MARZO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_mar)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_mar')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_mar"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_mar" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Marzo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_mar"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_mar)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_mar')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_mar"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_mar" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Marzo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_mar"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_mar)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_mar')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_mar"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_mar"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Marzo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_mar"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_mar)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_mar')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_mar"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_mar" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Marzo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_mar"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_mar)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_mar')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_mar"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_mar" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Marzo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_mar"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_mar)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_mar')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_mar"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_mar" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Marzo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_mar"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
          </template>

          <!-- TRIMESTRE 2 -->
          <template v-if="selectedQuarter === '2'">
            <!-- ABRIL -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_abr)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_abr')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_abr"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_abr" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Abril</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_abr"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_abr)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_abr')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_abr"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_abr" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Abril</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_abr"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_abr)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_abr')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_abr"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_abr"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Abril</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_abr"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_abr)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_abr')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_abr"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_abr" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Abril</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_abr"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_abr)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_abr')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_abr"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_abr" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Abril</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_abr"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_abr)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_abr')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_abr"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_abr" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Abril</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_abr"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- MAYO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_may)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_may')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_may"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_may" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Mayo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_may"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_may)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_may')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_may"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_may" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Mayo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_may"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_may)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_may')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_may"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_may"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Mayo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_may"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_may)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_may')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_may"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_may" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Mayo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_may"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_may)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_may')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_may"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_may" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Mayo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_may"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_may)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_may')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_may"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_may" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Mayo</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_may"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- JUNIO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_jun)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_jun')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_jun"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_jun" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Junio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_jun"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_jun)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_jun')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_jun"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_jun" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Junio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_jun"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_jun)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_jun')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_jun"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_jun"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Junio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_jun"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_jun)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_jun')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_jun"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_jun" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Junio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_jun"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_jun)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_jun')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_jun"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_jun" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Junio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_jun"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_jun)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_jun')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_jun"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_jun" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Junio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_jun"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
          </template>

          <!-- TRIMESTRE 3 -->
          <template v-if="selectedQuarter === '3'">
            <!-- JULIO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_jul)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_jul')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_jul"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_jul" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Julio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_jul"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_jul)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_jul')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_jul"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_jul" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Julio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_jul"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_jul)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_jul')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_jul"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_jul"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Julio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_jul"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_jul)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_jul')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_jul"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_jul" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Julio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_jul"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_jul)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_jul')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_jul"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_jul" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Julio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_jul"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_jul)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_jul')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_jul"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_jul" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Julio</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_jul"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- AGOSTO -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_ago)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_ago')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_ago"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_ago" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Agosto</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_ago"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_ago)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_ago')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_ago"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_ago" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Agosto</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_ago"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_ago)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_ago')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_ago"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_ago"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Agosto</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_ago"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_ago)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_ago')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_ago"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_ago" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Agosto</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_ago"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_ago)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_ago')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_ago"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_ago" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Agosto</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_ago"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_ago)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_ago')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_ago"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_ago" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Agosto</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_ago"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- SEPTIEMBRE  -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_sep)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_sep')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_sep"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_sep" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Septiembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_sep"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_sep)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_sep')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_sep"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_sep" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Septiembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_sep"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_sep)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_sep')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_sep"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_sep"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Septiembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_sep"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_sep)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_sep')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_sep"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_sep" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Septiembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_sep"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_sep)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_sep')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_sep"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_sep" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Septiembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_sep"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_sep)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_sep')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_sep"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_sep" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Septiembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_sep"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
          </template>

          <!-- TRIMESTRE 4 -->
          <template v-if="selectedQuarter === '4'">
            <!-- OCTUBRE -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_oct)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_oct')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_oct"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_oct" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Octubre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_oct"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_oct)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_oct')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_oct"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_oct" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Octubre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_oct"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_oct)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_oct')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_oct"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_oct"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Octubre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_oct"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_oct)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_oct')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_oct"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_oct" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Octubre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_oct"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_oct)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_oct')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_oct"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_oct" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Octubre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_oct"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_oct)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_oct')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_oct"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_oct" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Octubre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_oct"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- NOVIEMBRE -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_nov)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_nov')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_nov"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_nov" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Noviembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_nov"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_nov)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_nov')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_nov"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_nov" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Noviembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_nov"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_nov)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_nov')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_nov"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_nov"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Noviembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_nov"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_nov)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_nov')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_nov"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_nov" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Noviembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_nov"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_nov)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_nov')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_nov"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_nov" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Noviembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_nov"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_nov)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_nov')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_nov"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_nov" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Noviembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_nov"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>

            <!-- DICIEMBRE -->
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.issued_invoices_dic)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('issued_invoices_dic')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.issued_invoices_dic"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.issued_invoices_dic" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Emitidas Diciembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.issued_invoices_dic"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.received_invoices_dic)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('received_invoices_dic')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.received_invoices_dic"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.received_invoices_dic" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Recibidas Diciembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.received_invoices_dic"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.banking_transactions_dic)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') ||
                  filters.columns.includes('banking_transactions_dic')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.banking_transactions_dic"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label
                  :value="props.item.banking_transactions_dic"
                  :compact="compactView"
                />
                <template v-slot:input>
                  <div class="mt-3">Bancos Diciembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.banking_transactions_dic"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.openges_invoices_dic)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('openges_invoices_dic')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.openges_invoices_dic"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.openges_invoices_dic" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Openges Diciembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.openges_invoices_dic"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDocumentStatus(props.item.payroll_dic)"
              class="text-xs-center"
              v-if="filters.columns.includes('all') || filters.columns.includes('payroll_dic')"
            >
              <v-edit-dialog
                :return-value.sync="props.item.payroll_dic"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.payroll_dic" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Nóminas Diciembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.payroll_dic"
                    item-text="text"
                    item-value="value"
                    :items="monthlyStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
            <td
              :bgcolor="getBgColorForDefaulterStatus(props.item.defaulter_control_dic)"
              class="text-xs-center"
              v-if="
                filters.columns.includes('all') || filters.columns.includes('defaulter_control_dic')
              "
            >
              <v-edit-dialog
                :return-value.sync="props.item.defaulter_control_dic"
                large
                lazy
                persistent
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow()"
              >
                <og-status-label :value="props.item.defaulter_control_dic" :compact="compactView" />
                <template v-slot:input>
                  <div class="mt-3">Control Incumplidores Diciembre</div>
                  <v-select
                    color="primary"
                    v-model="props.item.defaulter_control_dic"
                    item-text="text"
                    item-value="value"
                    :items="defaulterControlOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </td>
          </template>

          <!-- SUPLEMENTO INCUMPLIDORES (trimestral) -->
          <td
            :bgcolor="getBgColorForDefaulterSupplement(props.item.defaulter_supplement)"
            class="text-xs-center"
            v-if="
              filters.columns.includes('all') || filters.columns.includes('defaulter_supplement')
            "
          >
            <v-edit-dialog
              :return-value.sync="props.item.defaulter_supplement"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <og-status-label :value="props.item.defaulter_supplement" :compact="compactView" />
              <template v-slot:input>
                <div class="mt-3">Suplemento Incumplidores</div>
                <v-select
                  color="primary"
                  v-model="props.item.defaulter_supplement"
                  item-text="text"
                  item-value="value"
                  :items="defaulterSupplementOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import stickyColumns from '@/directives/sticky-columns';
import '@/styles/og-compact-table.css';
import OgStatusLabel from '@/components/commons/OgStatusLabel';
import OgTableViewToggle from '@/components/commons/OgTableViewToggle';
import OgSavedFilters from '@/components/commons/OgSavedFilters';
import EmpresaAPI from '../../aplifisa/services/fiscal';
import ConsultantAPI from '../../customers-and-consultants/services/consultantAPI';

export default {
  name: 'CustomerAccountingControlTable',
  components: { OgStatusLabel, OgTableViewToggle, OgSavedFilters },
  directives: { stickyColumns },
  props: ['ownConsultant'],
  data() {
    return {
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      exportingExcel: false,
      updatingDocumentStatus: false,
      creatingAccountingControl: false,
      cloningAccountingControl: false,
      bulkSavingAccountingControl: false,
      showCreateAccountingControlForm: false,
      showDeleteAccountingControlForm: false,
      showCloneQuarterForm: false,
      showBulkEditForm: false,
      headers: [],
      compactView: true,
      accountingControlItems: [],
      exportFiscalObligationsList: [],
      year: null,
      nextYear: null,
      years: [],
      quarter: null,
      companiesList: [],
      consultantsList: [],
      consultantsFilterList: [],
      form: {
        allCompanies: false,
        companies: [],
        year: null,
        quarter: null,
        consultant_id: null,
        tax_regime: null,
        observations: null,
        showValidationErrors: false,
      },
      monthlyStatusOptions: [
        { text: 'NO TIENE', value: 'NO TIENE' },
        { text: 'NO TIENE (manual)', value: 'NO TIENE (manual)' },
        { text: 'NO NECESARIO', value: 'NO NECESARIO' },
        { text: 'NO CONTABILIZADO', value: 'NO CONTABILIZADO' },
        { text: 'EN PROCESO', value: 'EN PROCESO' },
        { text: 'CONTABILIZADO', value: 'CONTABILIZADO' },
        { text: 'EN BLANCO', value: 'EN BLANCO' },
      ],
      defaulterControlOptions: [
        { text: 'PENDIENTE', value: 'PENDIENTE' },
        { text: 'EN PLAZO', value: 'EN PLAZO' },
        { text: 'FUERA DE PLAZO', value: 'FUERA DE PLAZO' },
        { text: 'TRIMESTRAL/INACTIVA', value: 'TRIMESTRAL/INACTIVA' },
        { text: 'PRIMER AVISO', value: 'PRIMER AVISO' },
        { text: 'SEGUNDO AVISO', value: 'SEGUNDO AVISO' },
      ],
      defaulterSupplementOptions: [
        { text: 'SÍ', value: 'SÍ' },
        { text: 'NO', value: 'NO' },
        { text: 'APLICADO', value: 'APLICADO' },
        { text: 'COMUNICADO NO APLICADO', value: 'COMUNICADO NO APLICADO' },
      ],
      controlStatusOptions: [
        { text: 'EN PROCESO', value: 'EN PROCESO' },
        { text: 'CONTABILIZADO', value: 'CONTABILIZADO' },
        { text: 'CERRADO', value: 'CERRADO' },
        { text: 'SIN DATOS', value: 'SIN_DATOS' },
      ],
      taxRegimeOptions: [
        { text: 'IMP. SOCIEDADES', value: 'IMP. SOCIEDADES' },
        { text: 'E.D. SIMPLIFICADA', value: 'E.D. SIMPLIFICADA' },
        { text: 'E.D.S. (REPEP)', value: 'E.D.S. (REPEP)' },
        { text: 'E.D. OBJETIVA', value: 'E.D. OBJETIVA' },
        { text: 'E.D. NORMAL', value: 'E.D. NORMAL' },
      ],
      agencyOptions: [
        { text: 'ESTATAL', value: 'ESTATAL' },
        { text: 'CANARIAS', value: 'CANARIAS' },
        { text: 'F. VIZCAYA', value: 'F. VIZCAYA' },
        { text: 'F. NAVARRA', value: 'F. NAVARRA' },
        { text: 'F. GUIPUZCUA', value: 'F. GUIPUZCUA' },
        { text: 'F. ÁLAVA', value: 'F. ÁLAVA' },
      ],
      snack: false,
      snackText: '',
      snackColor: 'info',
      accountingControlPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 20, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      sortTable: false,
      filters: {
        name: '',
        consultant_ids: [],
        tax_regime: '',
        observations: '',
        search: '',
        selectedDocumentType: '',
        selectedDocumentStatus: '',
        columns: ['all'],
        previousColumns: [],
        controlStatus: '',
        defaulterControl: '',
        inmatic: '',
        has_billing_module: null,
      },
      clone: {
        showValidationErrors: false,
        originYear: null,
        originQuarter: null,
        destinyYear: null,
        destinyQuarter: null,
      },
      bulk: {
        fieldText: null,
        fieldValue: null,
        invoiceStatus: null,
        consultant: null,
        text: null,
        active: null,
        status: null,
        taxRegime: null,
        inmatic: null,
        defaulterControl: null,
        defaulterSupplement: null,
      },
    };
  },
  beforeMount() {
    // Calculate the quarter and year to avoid changing all time when it is time to generate it
    const today = new Date();
    const year = today.getFullYear();
    const nextYear = year + 1;

    const month = today.getMonth();
    const quarter = Math.floor(month / 3 + 1);

    this.year = year;
    this.nextYear = nextYear;
    this.quarter = quarter.toString();

    // Show T4 and previous year in January
    if (quarter === 1 && month === 0) {
      this.quarter = '4';
      this.year = year - 1;
    }

    // Show T1 in April
    if (quarter === 2 && month === 3) {
      this.quarter = '1';
    }

    // Show T2 in July
    if (quarter === 3 && month === 6) {
      this.quarter = '2';
    }

    // Show T3 in October
    if (quarter === 4 && month === 9) {
      this.quarter = '3';
    }
  },
  async mounted() {
    this.getYears();
    await this.getConsultantsList();
    if (this.ownConsultant) {
      this.filters.consultant_ids.push(this.ownConsultant);
    }
    // this.getAccountingControlList();
    this.getCompaniesList();
  },
  computed: {
    savedFiltersState() {
      return {
        year: this.year,
        quarter: this.quarter,
        filters: this.filters,
      };
    },
    currentPage() {
      return this.accountingControlPagination.page;
    },
    perPage() {
      return this.accountingControlPagination.rowsPerPage;
    },
    sortBy() {
      return this.accountingControlPagination.sortBy;
    },
    descending() {
      return this.accountingControlPagination.descending;
    },
    selectedConsultants() {
      return this.filters.consultant_ids;
    },
    search() {
      return this.filters.search;
    },
    selectedYear() {
      return this.year;
    },
    selectedQuarter() {
      return this.quarter;
    },
    filterColumnsList() {
      const all = [{ text: 'TODAS', value: 'all' }];
      return all.concat(this.headers);
    },
    editableControlStatusOptions() {
      return this.controlStatusOptions.map(item =>
        item.value === 'SIN_DATOS' ? { ...item, value: null } : item,
      );
    },
    selectedColumns() {
      return this.filters.columns;
    },
    documentTypes() {
      return this.headers.filter(item => {
        return (
          item.value.includes('issued') ||
          item.value.includes('received') ||
          item.value.includes('banking') ||
          item.value.includes('openges') ||
          item.value.includes('payroll')
        );
      });
    },
    selectedDocumentType() {
      return this.filters.selectedDocumentType;
    },
    selectedDocumentStatus() {
      return this.filters.selectedDocumentStatus;
    },
    selectedControlStatus() {
      return this.filters.controlStatus;
    },
    selectedDefaulterControl() {
      return this.filters.defaulterControl;
    },
    selectedInmaticStatus() {
      return this.filters.inmatic;
    },
    selectedHasBillingModuleStatus() {
      return this.filters.has_billing_module;
    },
  },
  methods: {
    applySavedFilters(saved) {
      const { columns, previousColumns } = saved.filters;
      this.year = saved.year;
      this.quarter = saved.quarter;
      this.filters = { ...this.filters, ...saved.filters };
      // El watcher del tipo de documento reescribe las columnas: se restauran al terminar
      this.$nextTick(() => {
        this.filters.columns = columns;
        this.filters.previousColumns = previousColumns;
      });
    },
    /**
     * Columnas que identifican la empresa (clavedat y nombre): quedan fijas a la izquierda
     * al desplazar la tabla en horizontal, junto con la casilla de selección.
     */
    isStickyColumn(value) {
      return ['clavedat', 'name'].includes(value);
    },
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 &&
          this.selectedItems.length < this.accountingControlItems.length)
      ) {
        let selected = [];
        this.accountingControlItems.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.accountingControlItems.length) {
        this.selectedItems = [];
      }
    },
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    updateConsultantRow(item) {
      let consultant = this.consultantsList.find(
        consultant => consultant.value === item.consultant_id,
      );
      if (consultant) {
        item.consultant = consultant.text;
      }
    },
    updateStatusRow(item) {
      item.active ? (item.active_text = 'ACTIVO') : (item.active_text = 'BAJA');
    },
    updateInmaticRow(item) {
      item.inmatic ? (item.inmatic_text = 'SÍ') : (item.inmatic_text = 'NO');
    },
    getYears() {
      const currentDate = new Date();
      let startYear = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;

      // If it is november or december we add the next year in the range
      if (month >= 11) {
        startYear = startYear + 1;
      }
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: startYear - i, value: startYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    getCompaniesList() {
      EmpresaAPI.getFiscalDataInputSelect().then(response => {
        this.companiesList = response.data;
      });
    },
    getConsultantsList() {
      ConsultantAPI.getConsultantInputSelect().then(response => {
        this.consultantsList = response.data.filter(item => !item.inactive);
        // Filters also list inactive consultants so their history can still be checked
        this.consultantsFilterList = this.consultantsList.concat(
          response.data
            .filter(item => item.inactive)
            .map(item => ({ ...item, text: `${item.text} (baja)` })),
        );
      });
    },
    resetForm() {
      this.form.showValidationErrors = false;
      this.form.year = null;
      this.form.quarter = null;
      this.form.companies = [];
      this.form.allCompanies = false;
      this.form.consultant_id = null;
      this.form.tax_regime = null;
      this.form.observations = null;
    },
    openCreateAccountingControlDialog() {
      this.resetForm();
      this.showCreateAccountingControlForm = true;
    },
    createAccountingControl() {
      if (
        !this.form.year ||
        !this.form.quarter ||
        !this.form.consultant_id ||
        !this.form.tax_regime ||
        (!this.form.allCompanies && !this.form.companies.length >= 1)
      ) {
        this.form.showValidationErrors = true;
      } else {
        this.creatingAccountingControl = true;
        apiCtrl
          .post('/admin/customer-accounting-control/create', this.form)
          .then(res => {
            console.log(res);
            this.creatingAccountingControl = false;
            this.showCreateAccountingControlForm = false;
            this.getAccountingControlList();
          })
          .catch(() => (this.creatingAccountingControl = false));
      }
    },
    getAccountingControlList() {
      this.loading = true;
      const config = {
        params: {
          year: this.year,
          quarter: this.quarter,
          page: this.accountingControlPagination.page,
          per_page: this.accountingControlPagination.rowsPerPage,
          sort_by: this.accountingControlPagination.sortBy,
          descending: this.accountingControlPagination.descending,
          consultant_ids: this.filters.consultant_ids,
          search: this.filters.search,
          document_type: this.filters.selectedDocumentType,
          document_status: this.filters.selectedDocumentStatus,
          status: this.filters.controlStatus,
          defaulter_control: this.filters.defaulterControl,
          inmatic: this.filters.inmatic,
          has_billing_module: this.filters.has_billing_module,
        },
      };
      apiCtrl
        .get('/admin/customer-accounting-control/list', config)
        .then(res => {
          console.log(res.data);
          this.accountingControlItems = res.data.data;
          this.headers = res.data.dataTable.headers;
          this.accountingControlPagination = {
            descending: this.accountingControlPagination.descending,
            page: this.accountingControlPagination.page,
            rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
            sortBy: this.accountingControlPagination.sortBy,
            totalItems: Number(res.data.meta.total),
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          // this.showSnackMessage(
          //   'error',
          //   'Se ha producido un error al cargar las obligaciones fiscales',
          // );
        });
    },
    deleteAccountingControl() {
      this.showDeleteAccountingControlForm = false;
      this.loading = true;
      let items = this.selectedItems.map(item => {
        return item.id;
      });
      apiCtrl
        .post('/admin/customer-accounting-control/delete', { ids: items })
        .then(() => {
          this.selectedItems = [];
          this.selectAllRows = false;
          this.getAccountingControlList();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveRow(item) {
      // Update manually the name of consultant of the updated row in case it had changed
      this.updateConsultantRow(item);

      // Update manually the name of status of the updated row in case it had changed
      this.updateStatusRow(item);

      // Update manually the inmatic status of the updated row in case it had changed
      this.updateInmaticRow(item);

      // Update the row entity in backend
      item.status = item.status === 'SIN_DATOS' ? null : item.status;
      apiCtrl
        .post('/admin/customer-accounting-control/update', item)
        .then(res => {
          console.log(res.data);
        })
        .catch(() => {
          // this.showSnackMessage('error', 'Se ha producido un error al actualizar');
          this.getAccountingControlList();
        });
    },
    cancelSaveRow() {},
    getBgColorForDocumentStatus(status) {
      let color = '#E6E6E6';
      if (!!status && status.includes('NO TIENE')) {
        status.includes('manual') ? (color = '#00AFA8') : (color = '#E6E6E6');
      } else if (!!status && status.includes('NO NECESARIO')) {
        color = '#E6E6E6';
      } else if (!!status && status.includes('NO CONTABILIZADO')) {
        color = '#A9A9A9';
      } else if (!!status && status.includes('EN PROCESO')) {
        color = '#FFB94F';
      } else if (!!status && status.includes('CONTABILIZADO')) {
        color = '#00AFA8';
      } else if (!!status && status.includes('EN BLANCO')) {
        color = '#FFFFFF';
      }

      return color;
    },
    getBgColorForDefaulterStatus(status) {
      let color = '#E6E6E6';
      if (status === 'EN PLAZO') {
        color = '#00AFA8';
      } else if (status === 'FUERA DE PLAZO') {
        color = '#FF7B7B';
      } else if (status === 'PRIMER AVISO' || status === 'SEGUNDO AVISO') {
        color = '#FFB94F';
      }

      return color;
    },
    getBgColorForDefaulterSupplement(status) {
      return status === 'SÍ' ? '#FF7B7B' : '';
    },
    getAccountingControlIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.accountingControlPagination.page,
        per_page: this.accountingControlPagination.rowsPerPage,
        search: this.filters.search,
      };

      setTimeout(() => {
        if (
          params.page === this.accountingControlPagination.page &&
          params.per_page === this.accountingControlPagination.rowsPerPage &&
          params.search === this.filters.search
        ) {
          this.getAccountingControlList();
        }
      }, 300);
    },
    openCloneQuarterDialog() {
      this.clone.showValidationErrors = false;
      this.clone.originYear = this.selectedYear;
      this.clone.originQuarter = this.selectedQuarter;
      this.clone.destinyYear = null;
      this.clone.destinyQuarter = null;
      this.showCloneQuarterForm = true;
    },
    cloneAccountingControl() {
      if (
        !this.clone.originYear ||
        !this.clone.originQuarter ||
        !this.clone.destinyYear ||
        !this.clone.destinyQuarter
      ) {
        this.clone.showValidationErrors = true;
      } else {
        this.cloningAccountingControl = true;
        apiCtrl
          .post('/admin/customer-accounting-control/clone', this.clone)
          .then(res => {
            console.log(res);
            this.cloningAccountingControl = false;
            this.showCloneQuarterForm = false;
            this.year = this.clone.destinyYear;
            this.quarter = this.clone.destinyQuarter;
          })
          .catch(() => (this.cloningAccountingControl = false));
      }
    },
    openBulkEditForm(text, value) {
      this.bulk.fieldValue = value;
      this.bulk.fieldText = text;

      this.bulk.consultant = null;
      this.bulk.invoiceStatus = null;
      this.bulk.text = null;
      this.bulk.active = null;
      this.bulk.status = null;
      this.bulk.taxRegime = null;
      this.bulk.inmatic = null;
      this.bulk.defaulterControl = null;
      this.bulk.defaulterSupplement = null;

      if (
        value !== 'name' &&
        value !== 'clavedat' &&
        value !== 'cif' &&
        value !== 'billing_module'
      ) {
        this.showBulkEditForm = true;
      }
    },
    saveBulkEditForm() {
      this.bulkSavingAccountingControl = true;
      let items = this.selectedItems.map(item => {
        return item.id;
      });
      apiCtrl
        .post('/admin/customer-accounting-control/bulk-edit', {
          selectedItems: items,
          field: this.bulk.fieldValue,
          invoiceStatus: this.bulk.invoiceStatus,
          consultant: this.bulk.consultant,
          text: this.bulk.text,
          active: this.bulk.active,
          status: this.bulk.status,
          tax_regime: this.bulk.taxRegime,
          inmatic: this.bulk.inmatic,
          defaulterControl: this.bulk.defaulterControl,
          defaulterSupplement: this.bulk.defaulterSupplement,
        })
        .then(res => {
          console.log(res);
          this.bulkSavingAccountingControl = false;
          this.showBulkEditForm = false;
          this.selectedItems = [];
          this.selectAllRows = false;
          this.getAccountingControlList();
        })
        .catch(() => {
          this.bulkSavingAccountingControl = false;
          this.showBulkEditForm = false;
        });
    },
    async exportToExcel() {
      this.exportingExcel = true;
      import('../../../../plugins/Export2Excel.js').then(async excel => {
        const filterColumns = this.filters.columns.includes('all')
          ? this.headers.map(header => header.value)
          : this.filters.columns;
        const exportHeaders = this.headers
          .filter(header => filterColumns.includes(header.value))
          .map(header => header.text);
        const config = {
          params: {
            year: this.year,
            quarter: this.quarter,
            sort_by: this.accountingControlPagination.sortBy,
            descending: this.accountingControlPagination.descending,
            consultant_ids: this.filters.consultant_ids,
            search: this.filters.search,
            document_type: this.filters.selectedDocumentType,
            document_status: this.filters.selectedDocumentStatus,
            page: 1,
            per_page: this.accountingControlPagination.totalItems,
            exportToExcel: true,
            status: this.filters.controlStatus,
            defaulter_control: this.filters.defaulterControl,
          },
        };
        let customerAccountingListToExport = [];
        await apiCtrl
          .get('/admin/customer-accounting-control/list', config)
          .then(res => {
            console.log(res.data);
            customerAccountingListToExport = res.data.data;
          })
          .catch(() => {
            this.showSnackMessage(
              'error',
              'Se ha producido un error al exportar el control contable',
            );
            this.exportingExcel = false;
          });
        const exportList = this.formatJson(filterColumns, customerAccountingListToExport);
        excel.export_json_to_excel({
          header: exportHeaders,
          data: exportList,
          filename: `Control_contable_${this.year}_Trimestre_${this.quarter}`,
          autoWidth: true,
          bookType: 'xlsx',
        });
        this.exportingExcel = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
    changeSort(column) {
      if (this.accountingControlPagination.sortBy === column) {
        this.accountingControlPagination.descending = !this.accountingControlPagination.descending;
      } else {
        this.accountingControlPagination.sortBy = column;
        this.accountingControlPagination.descending = false;
      }
    },
    syncDocumentStatus() {
      this.updatingDocumentStatus = true;
      const params = {
        year: this.year,
        quarter: this.quarter,
      };
      apiCtrl
        .post('/admin/customer-accounting-control/sync', params)
        .then(() => {
          this.getAccountingControlList();
          this.updatingDocumentStatus = false;
        })
        .catch(() => {
          this.updatingDocumentStatus = false;
          this.showSnackMessage(
            'error',
            'Se ha producido un error al actualizar el estado de los documentos',
          );
        });
    },
  },
  watch: {
    selectedYear: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    search: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedQuarter: function() {
      this.accountingControlItems = [];
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    currentPage: function() {
      this.getAccountingControlIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getAccountingControlList();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getAccountingControlList();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    selectedConsultants: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedDocumentType: function() {
      if (this.selectedDocumentType) {
        this.filters.previousColumns = [...this.filters.columns];
        if (this.filters.columns.find(column => column.includes('all'))) {
          this.filters.columns = [
            'clavedat',
            'name',
            'cif',
            'consultant',
            'tax_regime',
            'status',
            'active',
            'observations',
          ];
        } else {
          this.filters.columns = this.filters.columns.filter(
            column =>
              !column.includes('invoices') &&
              !column.includes('banking') &&
              !column.includes('payroll') &&
              !column.includes('defaulter_control'),
          );
        }

        this.filters.columns.push(this.selectedDocumentType);
      } else {
        this.filters.columns = [...this.filters.previousColumns];
        this.filters.selectedDocumentStatus = '';
      }
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedDocumentStatus: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedControlStatus: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedDefaulterControl: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedInmaticStatus: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
    selectedHasBillingModuleStatus: function() {
      if (this.currentPage === 1) {
        this.getAccountingControlIfStopChanges();
      } else {
        this.accountingControlPagination.page = 1;
      }
    },
  },
};
</script>

<style scoped>
.bg-lightgray {
  background-color: lightgray;
}
.bg-lightgreen {
  background-color: #00afa8;
}
.text-red {
  color: red;
}
</style>
